/**
 * Hooks React Query pour le blog
 */

import { useQuery } from '@tanstack/react-query';
import {
  fetchPosts,
  fetchPostBySlug,
  fetchFeaturedPosts,
  fetchPostsByCategory,
  fetchCategories,
  adaptPost
} from '@/lib/api';

// Hook pour récupérer tous les articles
export function usePosts() {
  return useQuery({
    queryKey: ['posts'],
    queryFn: async () => {
      const posts = await fetchPosts();
      return posts.map(adaptPost);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

// Hook pour récupérer un article par slug
export function usePost(slug: string) {
  return useQuery({
    queryKey: ['post', slug],
    queryFn: async () => {
      const post = await fetchPostBySlug(slug);
      return post ? adaptPost(post) : null;
    },
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
}

// Hook pour récupérer les articles en vedette
export function useFeaturedPosts() {
  return useQuery({
    queryKey: ['posts', 'featured'],
    queryFn: async () => {
      const posts = await fetchFeaturedPosts();
      return posts.map(adaptPost);
    },
    staleTime: 5 * 60 * 1000,
  });
}

// Hook pour récupérer les articles par catégorie
export function usePostsByCategory(categorySlug: string) {
  return useQuery({
    queryKey: ['posts', 'category', categorySlug],
    queryFn: async () => {
      const posts = await fetchPostsByCategory(categorySlug);
      return posts.map(adaptPost);
    },
    enabled: !!categorySlug,
    staleTime: 5 * 60 * 1000,
  });
}

// Hook pour récupérer les catégories
export function useCategories() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
